import React from 'react'
import { BusinessFunctionModel } from '../defs/defs'

interface BusinessFunctionBadgeProps {
    businessFunction: BusinessFunctionModel
    className?: string
}

const BusinessFunctionBadge: React.FC<BusinessFunctionBadgeProps> = ({ businessFunction, className = '' }) => {
    return (
        <div 
            className={`businessFunctionBadge category${businessFunction.shortName}`}
            title={businessFunction.name}
        >
            <span className="small">{businessFunction.shortName}</span>
        </div>
    )
}

export default BusinessFunctionBadge 